import { Injectable, signal } from '@angular/core';

/**
 * Coordinates a single in-flight "create item" (folder or table) request.
 * The create modal is sometimes rendered inside a dialog host, so a shared
 * service keeps the button disabled and blocks duplicate HTTP calls.
 */
@Injectable({ providedIn: 'root' })
export class CreateItemInFlightService {
  private readonly inFlight = signal(false);
  private readonly error = signal<string>('');
  readonly isInFlight = this.inFlight.asReadonly();
  readonly apiError = this.error.asReadonly();

  tryStart(): boolean {
    if (this.inFlight()) {
      return false;
    }
    this.inFlight.set(true);
    this.error.set('');
    return true;
  }

  setError(msg: string): void {
    this.inFlight.set(false);
    this.error.set(msg);
  }

  clearError(): void {
    this.error.set('');
  }

  clear(): void {
    this.inFlight.set(false);
    this.error.set('');
  }
}
